import { useMutation } from '@tanstack/react-query';
import { apiClient } from './client';
import { useChatStore, type ChatMessage } from '../store/chatStore';

interface ChatResponse {
  message: string;
  entity_mentions?: Array<{ id: string; name: string; type: string }>;
}

/**
 * POST /api/v1/agents/chat
 * Envoie un message au moteur de raisonnement Helios.
 */
async function sendChatMessage(message: string): Promise<ChatResponse> {
  const { data } = await apiClient.post<ChatResponse>('/agents/chat', {
    message,
  });
  return data;
}

/**
 * Hook pour envoyer un message et recevoir la reponse IA.
 */
export function useSendMessage() {
  const addMessage = useChatStore((s) => s.addMessage);
  const setLoading = useChatStore((s) => s.setLoading);

  return useMutation({
    mutationFn: async (message: string) => {
      // Ajouter le message utilisateur
      addMessage({ role: 'user', content: message });
      setLoading(true);

      try {
        const response = await sendChatMessage(message);
        addMessage({
          role: 'assistant',
          content: response.message,
          entityMentions: response.entity_mentions,
        });
        return response;
      } finally {
        setLoading(false);
      }
    },
  });
}

/**
 * Hook pour acceder a l'historique du chat (depuis le store Zustand).
 */
export function useChatHistory(): ChatMessage[] {
  return useChatStore((s) => s.messages);
}

/**
 * Hook pour vider l'historique du chat.
 */
export function useClearChat() {
  const clearMessages = useChatStore((s) => s.clearMessages);
  return clearMessages;
}
